import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { Text } from '@adc/ui-adc'
import styles from './index.scss'
const cx = classnames.bind(styles)

const Label = ({ bold, text }) => (
  <div className={cx('label')}>
    <Text data-elm-id='sticky_header_label_text' color='gray' size='small'>
      {text}
    </Text>
    {bold && (
      <Text
        data-elm-id='sticky_header_label_bold'
        className={cx('bold')}
        color='gray'
        size='small'
        weight='heavy'
      >
        {bold}
      </Text>
    )}
  </div>
)

Label.propTypes = {
  bold: PropTypes.string,
  text: PropTypes.string,
}

export default Label
